import BaseViz from './BaseViz'
import ParallelCoordsChart from '../charts/ParallelCoordsChart'
import { max as d3_max, min as d3_min, extent as d3_extent } from 'd3-array'
import ParallelCoordsDataController from '../viz_behaviors/ParallelCoordsDataController'
export default class RadarChartViz extends BaseViz {
  static defaultConfig = {
    showPoints: true,
    AxisHelper: {
      zoom: {
        value: false,
        exposed: false,
        nonEditable: true,
      },
      scroll: {
        value: false,
        exposed: false,
        nonEditable: true,
      },
      showScrollbar: {
        type: Boolean,
        default: false,
        exposed: false,
      },
      x: {
        dimensions: null,
        grid: false,
        tickOrientation: {
          nonEditable: true,
        },
        trimThreshold: {
          nonEditable: true,
        },
        valueFormat: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
        scale: {
          nonEditable: true,
        },
        domain: {
          nonEditable: true,
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false,
        },
        showTickValues: {
          nonEditable: true,
        },
        tickWrap: {
          nonEditable: true,
        },
      },
      y: {
        // tickFormat: ()=>'',
        grid: {
          value: false,
          nonEditable: true,
        },
        showTickValues: {
          value: false,
          nonEditable: true,
        },
        tickOrientation: {
          nonEditable: true,
        },
        getExtent: function (data, dimLabel) {
          // return [0,100]
          let tmp = Object.keys(data[0].dimensions).map(key =>
            d3_extent(data, l => l.dimensions[key])
          )
          let res = d3_extent(tmp.flat())
          return [Math.floor(res[0]), Math.ceil(res[1])]
        },
        trimThreshold: {
          nonEditable: true,
        },
        scale: {
          nonEditable: true,
        },
        domain: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
        tickWrap: {
          nonEditable: true,
        },
      },
    },
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true,
      },
      colorMode: 'stroke',
    },
  }
  static chartClass = ParallelCoordsChart
  static dataControllerClass = ParallelCoordsDataController
}
